import BossModel from "@/models/BossModel";

export default class CancelReason extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'dossier/cancel-reason';

    /**
     *
     * @type {string}
     */
    static entity = 'cancelReasons';

    static fields() {
		return {
			id: this.attr(null),
			name: this.attr(null),
			is_active: this.attr(null),
		}
	}

    /**
     * @param params
     * @returns {*}
     */
    static fetchAllForSelect(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(0)
            .get(true);
    }
}
